import React from 'react';
import { useParams } from 'react-router';

import PGA_countdown from './ads/pga/PGA_countdown';

const AdsCountdown = () => {
  const { adName } = useParams();

  let ads = null;
  if (adName === 'pga') {
    ads = <PGA_countdown key={'PGA_countdown'} />;
  }

  return <div className='AdsWrapper-300x250'>{ads}</div>;
};

export default AdsCountdown;
